import styled from "@emotion/styled";
import { IconButton } from "@mui/material";

export const Button = styled(IconButton)`
  display: inline-flex;
  transition:
    outline-color 0.3s ease,
    color 0.3s ease;
  outline: ${p => p.theme.space[1]}px solid transparent;
  background-color: ${props => props.theme.colors.white};
  border-radius: 7px;
  margin-right: ${p => p.theme.space[5]}px;

  &:hover,
  &:focus {
    outline-color: ${props => props.theme.colors.accent.green};
  }

  @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
    display: none;
  }
`;
